import { ProductModel } from './product';

export const PURCHASE_SOURCE_NAME_MAP = {
  direct: '링크 이동',
  collection: '기획전',
  'purchased-products-cell': '지금 막 결제되었어요',
  'recommend-products-by-distance': '근처 상품 추천',
  'search-results': '검색 결과',
  'partner-info': '파트너 프로필',
  'purchase-page': '결제 내역',
  'my-favorites': '나의 찜',
  'chat-page': '채팅',
  'recommend-products-weekly-favorites': '한 주간 가장 많이 찜한 상품',
  'recommend-products': '함께 보면 좋은 상품',
  'theme-collection': '테마 기획전',
  'deep-link': '앱 링크',
  'tutor-info-review-user-content': '튜터 정보 리뷰 콘텐츠',
  'partner-profile-user-content': '파트너 프로필 콘텐츠',
  'lounge-page-user-content': '라운지 페이지 콘텐츠',
  'user-content-detail': '콘텐츠 상세 페이지',
  'product-detail-footer': '상품 상세 하단',
  'product-favorite': '찜하기 버튼',
  'product-share': '공유 버튼',
  'product-grid-cell-12': '메인피드(12번째 상품 섹션)',
  'product-general-cell-9': '메인피드(9번째 상품 섹션)',
  'purchased-products-cell-4': '결제한 상품(4번째 섹션)',
  'purchased-products-cell-2': '결제한 상품(2번째 섹션)',
  'purchased-products-cell-5': '결제한 상품(5번째 섹션)',
  'product-general-cell-11': '메인피드(11번째 상품 섹션)',
  'product-review-summary': '상품 리뷰 요약',
  'events-page': '이벤트 페이지',
  'product-grid-cell-10': '메인피드(10번째 상품 섹션)',
  'product-general-cell-6': '메인피드(6번째 상품 섹션)',
  'product-general-cell-13': '메인피드(13번째 상품 섹션)',
  'vertical-banner-cell-0': '메인피드(0번째 배너 섹션)',
  'push-notification': '푸시 알림',
  'seller-review-summary': '파트너 리뷰 요약',
  'lounge-detail': '라운지 상세',
  'shortcut-cell-2': '메인피드 숏컷(2번째 섹선)',
  'deals-page-home-billboard': '특가홈 빌보드',
  'deals-page-home-daily-deal': '특가홈 하루특가',
  'deals-page-home-last-chance': '특가홈 라스트찬스',
  'deals-page-home-time-sale': '특가홈 타임세일',
  'deals-page-last-chance': '특가 라스트찬스',
  'deals-page-time-sale': '특가 타임세일',
  'deals-page-time-sale-sub-carousel': '특가 타임세일 기획전',
  'main-feed-v2-banner': '발견 대배너',
  'shortcut-v2-cell': '발견 미니배너(숏컷)',
};

export const PRODUCT_EXPOSURE_SOURCE_NAME_MAP = {
  'collection-main-page': '기획전',
  'recommend-products-by-distance': '근처 상품 추천',
  'search-results': '검색 결과',
  'partner-info': '파트너 프로필',
  'my-favorites': '나의 찜',
  'recommend-products-weekly-favorites': '한 주간 가장 많이 찜한 상품',
  'recommend-products': '함께 보면 좋은 상품',
  'tutor-info-review-user-content': '튜터 정보 리뷰 콘텐츠',
  'partner-profile-user-content': '파트너 프로필 콘텐츠',
  'lounge-page-user-content': '라운지 페이지 콘텐츠',
  'user-content-detail': '콘텐츠 상세 페이지',
  'purchased-products-cell': '메인피드(지금 막 결제되었어요)',
  'product-general-cell': '메인피드(일반)',
  'product-grid-cell': '메인피드(그리드)',
  'vertical-banner-cell': '메인피드(세로형)',
  'commerce-carousel': '메인피드(커머스 캐러셀)',
  default: '기타',
};

export interface Counts {
  dau?: number;
  mau?: number;
  visits?: number;
  visitUsers?: number;
  newParentUsers?: number;
  newTutorUsers?: number;
  newSellerUsers?: number;
  newInstructorUsers?: number;
  samePastPeriod?: {
    dau: number;
    mau: number;
    visits: number;
    visitUsers: number;
    newParentUsers: number;
    newTutorUsers: number;
    newSellerUsers: number;
    newInstructorUsers: number;
  };
}

export interface UserCounts {
  tutor: number;
  parent: number;
  seller: number;
  instructor: number;
  editor: number;
  admin: number;
}

export interface DailyCount {
  _id: { year: number; month: number; day: number };
  count: number;
}

export interface ProductCountSummary {
  _id: string;
  productId: string;
  productName?: string;
  view: number;
  favorite: number;
  share: number;
}

export interface DailyPaymentNewCount {
  _id: string;
  buyerCount: number;
  class: number;
  commerce: number;
  naver: number;
  kakao: number;
  ezwel: number;
  classAmount: number;
  commerceAmount: number;
  naverAmount: number;
  kakaoAmount: number;
  ezwelAmount: number;
  refundClass: number;
  refundCommerce: number;
  refundNaver: number;
  refundKakao: number;
  refundEzwel: number;
}

export interface DailyPaymentCount {
  _id: { year: number; month: number; day: number };
  buyerCount: number;
  class: number;
  commerce: number;
  naver: number;
  kakao: number;
  ezwel: number;
  classAmount: number;
  commerceAmount: number;
  naverAmount: number;
  kakaoAmount: number;
  ezwelAmount: number;
  refundClass: number;
  refundCommerce: number;
  refundNaver: number;
  refundKakao: number;
  refundEzwel: number;
}

export interface DailyPointUsageCount {
  _id: string;
  class: number;
  commerce: number;
  classPoint: number;
  commercePoint: number;
}

export interface DailyNetSales {
  _id: string;
  totalNetSales: number;
  totalNetSalesForSpecialSeller: number;
  totalNetSalesForOthers: number;
}

export interface ProductCounts {
  class: ProductDefaultCounts;
  commerce: ProductDefaultCounts;
}

export interface PaymentCountsData {
  hasIncome: number;
  total: number;
}
export interface PaymentCounts {
  seller: PaymentCountsData;
  tutor: PaymentCountsData;
  commerce: number;
  class: number;
  samePastPeriod: {
    seller: PaymentCountsData;
    tutor: PaymentCountsData;
    commerce: number;
    class: number;
  };
}

export interface ProductDefaultCounts {
  total: number;
  open: number;
  close: number;
  display: { open: number; close: number };
  private: number;
  requested: number;
  accepted: number;
  denied: number;
  edit: number;
  deleted: number;
}

export interface PaymentRankData {
  _id: string;
  productName?: string;
  sellerName: string;
  saleType: string;
  count: number;
  amount: number;
}

export interface ChatCounts {
  new: number;
  class: number;
  user: number;
  samePastPeriod: {
    new: number;
    class: number;
    user: number;
  };
}

export interface ProductCount {
  _id: string;
  exposure: number;
  viewConversionRate: number;
  view: number;
  chatStart: number;
  chatReopen: number;
  payment: number;
  paymentAmount: number;
  paymentPointAmount: number;
  refund: number;
  refundAmount: number;
  share: number;
  favorite: number;
  purchase: number;
  purchaseOption: number;
  product?: ProductModel;
  from?: { [key: string]: number };
  conversions?: { purchaseOption: number; purchase: number; payment: number; total: number };
}

export interface ProductExposeCount {
  _id: string;
  productId: string;
  productName: string;
  partnerName: string;
  partnerId: string;
  totalCount: number;
  locations: {
    source: string;
    count: number;
  }[];
  createdAt: Date;
  day: string;
  weekOfYear: string;
}

export interface ClickData {
  _id: {
    actionId: string;
    actionType: string;
    collectionId?: string;
    productId?: string;
    link?: string;
    keyword?: string;
  };
  count: number;
}

export interface SalesReport {
  _id: {
    sellerId: string;
    sellerName: string;
    productId?: string;
    productName?: string;
    productType?: string;
  };
  children?: any;
  productId?: string;
  totalCount: number;
  totalRefundCount: number;
  totalAmount: number;
  totalBilling: number;
  totalPoint: number;
  totalRefund: number;
  naverCount: number;
  naverAmount: number;
  naverRefund: number;
  kakaoCount: number;
  kakaoAmount: number;
  kakaoRefund: number;
  ezwelCount: number;
  ezwelAmount: number;
  ezwelRefund: number;
  appCount: number;
  appAmount: number;
  appRefund: number;
}

export interface CumulativeHourlySales {
  baseDate: string;
  today: Array<{
    hour: number;
    total: number;
    class: number;
    commerce: number;
    naver: number;
    kakao: number;
    ezwel: number;
  }>;
  lastWeek: Array<{
    hour: number;
    total: number;
    class: number;
    commerce: number;
    naver: number;
    kakao: number;
    ezwel: number;
  }>;
}

export interface PurchasesReport {
  _id: {
    id?: string;
    phoneNumber: string;
    userName?: string;
    joinDate?: Date;
    productType?: string;
  };
  productTypes?: string[];
  userName: string;
  firstPaidDate: Date;
  lastPaidDate: Date;
  totalCount: number;
  totalRefundCount: number;
  totalAmount: number;
  totalBilling: number;
  totalPoint: number;
  totalRefund: number;
  naverCount: number;
  naverAmount: number;
  naverRefund: number;
  naverRefundCount: number;
  kakaoCount: number;
  kakaoAmount: number;
  kakaoRefund: number;
  kakaoRefundCount: number;
  appCount: number;
  appAmount: number;
  appRefund: number;
  appRefundCount: number;
}

export interface SessionDurationData {
  date: string;
  medianDuration: number;
  trimmedMeanDuration: number;
  sessionCount: number;
}

export interface ProductInteractionData {
  date: string;
  viewCount: number;
  favoriteCount: number;
  purchaseClickCount: number;
  reviewClickCount: number;
  shareCount: number;
  paymentClickCount: number;
  actualPaymentCount: number;
  favoriteRatio: number;
  purchaseRatio: number;
  reviewRatio: number;
  shareRatio: number;
  paymentRatio: number;
  actualPaymentRatio: number;
}

export interface PaymentTimeSlotTrendsData {
  dayOfWeek: number; // 1=일요일, 2=월요일, ..., 7=토요일
  dayOfWeekString: string; // "월요일"
  timeSlots: {
    timeSlot: number; // 0-47
    timeSlotString: string; // "09:00", "09:30"
    totalCount: number;
    app: number;
    naverStore: number;
    kakaoReservation: number;
    ezwel?: number;
    appAmount: number;
    naverStoreAmount: number;
    kakaoReservationAmount: number;
    ezwelAmount?: number;
  }[];
}

export interface ProductClickLocationData {
  _id: string; // 날짜 (YYYY-MM-DD)
  locations: {
    locationId: string; // 클릭 위치 ID
    count: number; // 클릭 수
  }[];
  totalCount: number; // 해당 날짜 총 클릭 수
}

export interface PartnerProfileViewCountData {
  partnerId: string;
  partnerName: string;
  count: number;
}

export interface PartnerProfileClickCountData {
  partnerId: string;
  partnerName: string;
  sourceId?: string;
  count: number;
}

export interface MonthlyPaymentComparisonData {
  _id: {
    year: number;
    month: number;
  };
  monthString: string; // "2024-01"
  currentYear: {
    totalAmount: number;
    count: number;
  };
  previousYear: {
    totalAmount: number;
    count: number;
  };
  growth: {
    amountGrowthRate: number; // 금액 증가율 (%)
    countGrowthRate: number; // 건수 증가율 (%)
  };
}

export interface DiscoverFeedItemStats {
  itemId: string;
  title: string;
  impressions: number;
  clicks: number;
  ctr: number;
}

export interface DiscoverFeedDailyStats {
  date: string;
  tabViews: number;
  bannerImpressions: number;
  bannerClicks: number;
  shortcutImpressions: number;
  shortcutClicks: number;
}

export interface DiscoverFeedStats {
  dailyTabViews: { date: string; count: number }[];
  banners: DiscoverFeedItemStats[];
  shortcuts: DiscoverFeedItemStats[];
  daily: DiscoverFeedDailyStats[];
}
